import { Component, OnInit, OnDestroy, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { PaymentMethodComponent } from 'src/app/pos-order/components/payment-method/payment-method.component';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-email-invoice',
  templateUrl: './email-invoice.component.html',
  styleUrls: ['./email-invoice.component.css'],
})
export class EmailInvoiceComponent implements OnInit, OnDestroy {
  images = { CROSS };
  validateForm!: FormGroup;
  isLoading: boolean = false;
  private subscriptions: Subscription = new Subscription();
  private orderId: string | undefined;

  constructor(
    private dialogRef: MatDialogRef<PaymentMethodComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private _fb: FormBuilder,
    private _translateService: TranslateService,
    private _localStorage: LocalStorageService,
    private _apiService: ApiService,
    private _msgService: MessageService,
  ) {
    this._translateService.use(this._localStorage.get('language') || 'en_US');
  }

  ngOnInit(): void {
    this.initView();
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  onCancelClick(): void {
    this.dialogRef.close({ data: 'closed' });
  }

  sendEmail(): void {
    if (this.validateForm.invalid) {
      this.markFormControlsAsDirty();
      return;
    }
    this.sendEmailInvoice();
  }

  private initView(): void {
    this.orderId = this.data?.orderID;
    this.initializeForm();
  }

  private initializeForm(): void {
    this.validateForm = this._fb.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  private markFormControlsAsDirty(): void {
    Object.values(this.validateForm.controls).forEach((control) => {
      control.markAsDirty();
      control.updateValueAndValidity();
    });
  }

  private sendEmailInvoice(): void {
    const emailInvoicePayload = {
      email: this.validateForm.value.email,
      order_id: this.orderId,
    };

    this.isLoading = true;

    const subscription = this._apiService
      .emailInvoiceToUser(emailInvoicePayload)
      .subscribe(
        (response: any) => {
          if (response?.statusCode === 201) {
            this._msgService.showSuccess(response?.data?.message);
            this.dialogRef.close({ data: 'closed' });
          } else {
            this._msgService.showError(response?.data?.message);
          }
        },
        (error) => {
          this.isLoading = false;
          this._msgService.showError(
            error?.error?.message || 'An error occurred'
          );
        }
      );

    this.subscriptions.add(subscription);
  }
}
